export default "__VITE_ASSET__CHKRHo1i__"